
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/player/[...permalink]",
      function () {
        return require("private-next-pages/player/[...permalink].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/player/[...permalink]"])
      });
    }
  